/* GENERATED FILE — DO NOT EDIT.
 *
 * The muscle SYNONYM table, emitted from the file the phone compiles:
 *   HybridTrainer/Services/AI/MuscleNormalizer.swift
 *
 * Regenerate:  node web/tools/gen-muscle-synonyms.mjs
 * A vitest ruler regenerates this in memory on every run and fails if it differs.
 *
 * ⚠️ WHAT THIS IS FOR, AND THE ONE THING IT DOES NOT PROMISE. `muscles.ts` holds the enum's 24
 * CASES; this holds the 133 SPELLINGS those cases answer to, which is what makes
 * "can the engine read this?" answerable on the web at all. It resolves a phrase to a LABEL.
 * The whole-word rule for phrases of ≤ 3 characters (E2) is the LOOKUP's, not this table's: it
 * lives in the Swift scan and in its port, `muscleVocabulary.ts`.
 *
 * ⚠️ IT IS NOT A PROMISE ABOUT WHICH MUSCLE, ON A TIE. Swift scans the miss path longest-phrase
 * first and breaks equal-length ties by DICTIONARY ORDER, which is hash-ordered and therefore not
 * deterministic even between two runs of the phone — its own comment says so. Every tie still
 * resolves to SOMETHING, so the READABLE/NOT question this file exists to answer is unaffected;
 * a caller wanting the identity of the muscle must ask the engine, not this table.
 */
export const MUSCLE_SYNONYMS: Readonly<Record<string, string>> = {
  "quad": "Quadriceps",
  "quadricep": "Quadriceps",
  "quadricep femoris": "Quadriceps",
  "front thigh": "Quadriceps",
  "vastus lateralis": "Quadriceps",
  "vastus medialis": "Quadriceps",
  "vastu laterali": "Quadriceps",
  "vastu mediali": "Quadriceps",
  "hamstring": "Hamstrings",
  "ham": "Hamstrings",
  "biceps femoris": "Hamstrings",
  "rear thigh": "Hamstrings",
  "posterior chain": "Hamstrings",
  "glute": "Glutes",
  "gluteus maximus": "Glutes",
  "gluteus medius": "Glutes",
  "gluteus minimus": "Glutes",
  "buttock": "Glutes",
  "gluteal": "Glutes",
  "adductor": "Adductors",
  "inner thigh": "Adductors",
  "groin": "Adductors",
  "abductor": "Abductors",
  "outer thigh": "Abductors",
  "hip abductor": "Abductors",
  "hip": "Glutes",
  "hip rotator": "Glutes",
  "calf": "Calves",
  "calve": "Calves",
  "gastrocnemiu": "Calves",
  "gastrocnemius": "Calves",
  "soleu": "Calves",
  "soleus": "Calves",
  "posterior tibiali": "Calves",
  "hip flexor": "Hip Flexors",
  "iliopsoa": "Hip Flexors",
  "iliopsoas": "Hip Flexors",
  "psoa": "Hip Flexors",
  "psoas": "Hip Flexors",
  "lat": "Lats",
  "latissimus dorsi": "Lats",
  "latissimus": "Lats",
  "wing": "Lats",
  "latissimu dorsi": "Lats",
  "latissimu": "Lats",
  "trap": "Traps",
  "trapeziu": "Traps",
  "trapezius": "Traps",
  "mid trap": "Traps",
  "upper trap": "Traps",
  "lower trap": "Traps",
  "rhomboid": "Rhomboids",
  "scapular retractor": "Traps",
  "scapular muscle": "Traps",
  "levator scapulae": "Traps",
  "scapular stabilizer": "Traps",
  "erector spinae": "Lower Back",
  "erector": "Lower Back",
  "spinal erector": "Lower Back",
  "lower back": "Lower Back",
  "low back": "Lower Back",
  "lumbar": "Lower Back",
  "spine": "Lower Back",
  "upper back": "Rhomboids",
  "mid back": "Rhomboids",
  "back": "Lats",
  "chest": "Chest",
  "pec": "Chest",
  "pectoral": "Chest",
  "pectorali major": "Chest",
  "pectoralis major": "Chest",
  "pectorali minor": "Chest",
  "upper chest": "Chest",
  "lower chest": "Chest",
  "serratu": "Serratus",
  "serratus anterior": "Serratus",
  "serratus": "Serratus",
  "anterior deltoid": "Front Delts",
  "front delt": "Front Delts",
  "front deltoid": "Front Delts",
  "anterior delt": "Front Delts",
  "lateral deltoid": "Side Delts",
  "side delt": "Side Delts",
  "medial deltoid": "Side Delts",
  "lateral delt": "Side Delts",
  "posterior deltoid": "Rear Delts",
  "rear delt": "Rear Delts",
  "rear deltoid": "Rear Delts",
  "posterior delt": "Rear Delts",
  "posterior shoulder": "Rear Delts",
  "shoulder": "Front Delts",
  "delt": "Front Delts",
  "deltoid": "Front Delts",
  "rotator cuff": "Rotator Cuff",
  "infraspinatu": "Rotator Cuff",
  "supraspinatu": "Rotator Cuff",
  "infraspinatus": "Rotator Cuff",
  "supraspinatus": "Rotator Cuff",
  "subscapulari": "Rotator Cuff",
  "external rotator": "Rotator Cuff",
  "shoulder rotator": "Rotator Cuff",
  "neck": "Neck",
  "sternocleidomastoid": "Neck",
  "bicep": "Biceps",
  "biceps brachii": "Biceps",
  "brachiali": "Biceps",
  "brachialis": "Biceps",
  "tricep": "Triceps",
  "triceps brachii": "Triceps",
  "forearm": "Forearms",
  "grip": "Forearms",
  "brachioradiali": "Forearms",
  "brachioradialis": "Forearms",
  "wrist flexor": "Forearms",
  "wrist extensor": "Forearms",
  "wrist": "Forearms",
  "hand intrinsic": "Forearms",
  "ab": "Abs",
  "abdominal": "Abs",
  "abs": "Abs",
  "rectus abdomini": "Abs",
  "rectus abdominis": "Abs",
  "rectu abdomini": "Abs",
  "core": "Abs",
  "six pack": "Abs",
  "oblique": "Obliques",
  "external oblique": "Obliques",
  "internal oblique": "Obliques",
  "side ab": "Obliques",
  "transverse abdomini": "Deep Core",
  "transverse abdominis": "Deep Core",
  "tva": "Deep Core",
  "deep core": "Deep Core",
};

export const MUSCLE_SYNONYM_COUNT = 133;
